import React from 'react';
import { Grid } from '@mui/material';
import { Create as PresentationIcon } from '@mui/icons-material';
import { TextField, EmailField, WebsiteField } from '../../CommonComponents/Form';
import { SectionDivider } from '../../CommonComponents';

interface ContactInfoProps {
    entity: any;
    onChange: (e: React.ChangeEvent<any>) => void;
}

const ContactInfoBlock = ({ entity, onChange }: ContactInfoProps) => (
    <Grid item md={12} lg={6}>
        <SectionDivider label="Kontaktuppgifter" marginTop={2} marginBottom={0} />
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <EmailField
                    name="email"
                    label="E-post"
                    value={entity.email}
                    onChange={onChange}
                />
            </Grid>
            <Grid item xs={12}>
                <TextField
                    name="phone"
                    label="Telefon"
                    value={entity.phone}
                    onChange={onChange}
                />
            </Grid>
            <Grid item xs={12}>
                <WebsiteField
                    name="website"
                    label="Hemsida"
                    value={entity.website}
                    onChange={onChange}
                />
            </Grid>
        </Grid>
        <SectionDivider
            label="Om företaget"
            icon={<PresentationIcon fontSize="small" />}
            marginTop={3}
        />
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <TextField
                    name="description"
                    label="Presentationstext"
                    value={entity.description}
                    onChange={onChange}
                    multiline
                    minRows={6}
                    maxLength={599}
                />
            </Grid>
        </Grid>
    </Grid>
);

export default React.memo(ContactInfoBlock);
